module.exports = __webpack_public_path__ + "static/media/rUSD.b5127093.svg";